export default __webpack_public_path__ + "static/media/AFTIM-img-3.0e4b17a3.jpg";